<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="商品搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入商品名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            <el-button type="primary" style="margin-left: 40px;" @click="addGoodsOpenBtn">添加商品</el-button>
          </el-form-item>
        </el-form>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="商品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="secKillPrice"
            label="秒杀价格">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiSpecPrice"
            label="售价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="stockNum"
            label="库存">
          </el-table-column>
          <el-table-column
            align="center"
            prop="buyLimit"
            label="购买限制">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1" class="mt-green">开启</span>
              <span v-else class="mt-red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 添加商品弹窗 -->
    <el-dialog
      title="添加商品"
      :visible.sync="addGoodsShow"
      width="960px">
      <el-form :model="oneForm" label-width="140px">
        <el-form-item label="商品：" prop="goodsId">
          <el-select style="width: 420px;" v-model="oneForm.goodsId" placeholder="请选择商品">
            <el-option v-for="(item,index) in goodsList" :key="index" :label="item.goodsName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序：" prop="sort">
          <el-input style="width: 420px;" v-model="oneForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { modelFunGoodsList, modelFunAddGoodsList, modelFunAddGoodsSave, removeSecKillGoodsByKillIdAndGoodsId  } from '@/api/seckill'
export default {
  name: 'SeckillGoodsList',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 添加商品弹窗
      addGoodsShow:false,
      oneForm:{
        goodsId:'',
        sort:''
      },
      goodsList:[]
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      modelFunGoodsList({ goodsName: searchName, secKillId: that.dataId, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 添加商品弹窗-打开弹窗操作 */
    addGoodsOpenBtn () {
      var dataId = this.dataId
      let that = this
      modelFunAddGoodsList({ id: dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.goodsList = data;
          that.addGoodsShow = true;
        }else{
          that.$message.error(res.msg);
        }
      })
    },
    // 添加商品弹窗-保存操作
    saveBtn(){
      var that = this
      var dataId = that.dataId
      var goodsId = that.oneForm.goodsId
      let sort = that.oneForm.sort === '' ? 1 : that.oneForm.sort
      if (goodsId === '') {
        this.$message.error('请选择商品')
        return false
      }
      var secKillGoodsBindSaveDtoList = [{
        secKillGoodsId:goodsId,
        sort:sort
      }]
      let passData = {
        secKillId: dataId, secKillGoodsBindSaveDtoList: secKillGoodsBindSaveDtoList
      }
      that.fullscreenLoading = true;
      modelFunAddGoodsSave(passData).then((res) => {
        that.fullscreenLoading = false;
        if(res.errorCode == "0000"){
          that.$message.success(res.msg);
          that.oneForm.goodsId = '';
          that.oneForm.sort = '';
          that.addGoodsShow = false;
          that.currentPage = 1;
          that.getInfoList();
        }
        if(res.errorCode == "1001"){
          that.$message.error(res.msg);
        }
      })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeSecKillGoodsByKillIdAndGoodsId({ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/seckill/SeckillGoodsList.vue